
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function customDialogButtonRT () {
    return _createElement('div', { 'className': 'cm_button' });
}
        export const componentNames = []